// extracted by mini-css-extract-plugin
module.exports = {"aplixInputFullWidth":"aplixInputFullWidth--1373a","aplixInputDisabled":"aplixInputDisabled--1f7ba"};